import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  instructionCardFlex: {
    background: '#FFF',
    border: '1px solid rgba(44, 45, 62, 0.3)',
    borderRadius: '8px',
    margin: '10px',
    height: 200
  },
  instructionTitle:{
    marginLeft: '10px', 
    textAlign: 'left', 
    maxHeight: 40, 
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    paddingRight: 5,
    maxWidth: 300
  },
  instructionTitleEdit:{
    width: 'calc(100% - 110px)', 
  },
  instructionDescription:{
    marginLeft: '10px', 
    textAlign: 'left', 
    height: 100,
    overflow: 'overlay', 
    textOverflow: 'ellipsis',
    paddingRight: 10
  },
  instructionDetails:{
    position: 'absolute',
    right: '30px',
    bottom: '5px',
  }
}));

export { useStyles };
